/*
#############################################################################
# Copyright (c) 2022-2023 NVIDIA CORPORATION & AFFILIATES. All rights reserved.
#
# NVIDIA CORPORATION, its affiliates and licensors retain all intellectual
# property and proprietary rights in and to this material, related
# documentation and any modifications thereto. Any use, reproduction,
# disclosure or distribution of this material and related documentation
# without an express license agreement from NVIDIA CORPORATION or
# its affiliates is strictly prohibited.
###############################################################################
*/

/* eslint-disable react/prop-types */
import * as React from "react";
import Backdrop from "@mui/material/Backdrop";
import { useNavigate } from "react-router-dom";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";

function ErrorFallback({ error, resetErrorBoundary }) {
  const navigate = useNavigate();
  const handleReset = () => {
    navigate("/WELCOME_VIEW");
    window.location.reload();
  };

  return (
    <div>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open
      >
        <Box>
          <Typography variant='p'>
            {`Something went wrong: ${error.message}`}
          </Typography>
          <br />
          <Button onClick={resetErrorBoundary}>Try again</Button>
          <Button onClick={handleReset} color='error'>
            Reset
          </Button>
        </Box>
      </Backdrop>
    </div>
  );
}

export default ErrorFallback;
